import { createFileRoute } from '@tanstack/react-router'
import { Outlet } from '@/libs/router'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/hr/time-off')({
	component: TimeOffLayout,
})

function TimeOffLayout() {
	return (
		<PageLayout data-id='time-off-page'>
			<Outlet />
		</PageLayout>
	)
}
